import classNames from 'classnames';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { config } from '../../common/';
import VehicleSubscription from '../../subscription/components/VehicleSubscription';
import Maps from './Maps';
import css from './PrimeLanding.scss';

const PrimeLanding: React.FC<{}> = () => {
    const { t } = useTranslation();
    return (
        <React.Fragment>
            <div className={classNames(['grid-x', 'grid-margin-x', 'my-bmw-servicos-value-service-prime'])}>
                <VehicleSubscription vehcode={-2} isLanding={true} />
                <div className="row">
                    <div className={css.headerStl}>
                        <h2>{t('subscriptions:landing.map-header')}</h2>
                    </div>
                    <Maps />
                    <div className={css.headerStl}>
                        <p>
                            {t('subscriptions:landing.footer-note')}
                            <br />
                            <a href={config.MapsTerms}>{t('subscriptions:landing.footer-link1')}</a>
                            {' e a '}
                            <a href={config.MapsPrivacy}>{t('subscriptions:landing.footer-link2')}</a>
                        </p>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default PrimeLanding;
